import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { handleDeleteReport, handleGenerateReport } from '../actions/emailReportsActions'
import { Link } from 'react-router-dom'

export const ReportActionCell = (props) => {
    return (
        <React.Fragment>
            <Button size="sm" outline color='primary' onClick={() => props.handleGenerateReport(props.row.id)}>Send Now</Button>{' '}
            <Link to={{
                pathname: '/EmailReport/Create',
                state: { existingId: props.row.id }
            }}>
                <Button size="sm" outline color='primary'>Edit</Button>
            </Link>{' '}
            <Button size="sm" outline color="danger" onClick={() => props.handleDeleteReport(props.row.id)}>{props.row.deleting ? 'Deleting...' : 'Delete'}</Button>
        </React.Fragment>
    )
}

const mapDispatchToProps = {
    handleDeleteReport,
    handleGenerateReport
}

export default connect(null, mapDispatchToProps)(ReportActionCell)